import {
  DataBlockFieldDto,
  DataType,
  MeasurementMappingDto,
} from '@lmt/shared-types';
import { MeasuredValue } from './types';
import {
  calculateFormula,
  formulaPrefix,
} from '../../miniscreen-importer/utils/calculation';
import { localizeDataType } from '../../measurement-fields/common';
import { parseFhirTime } from './parsing';

export function mapMeasuredValues(
  measuredValues: MeasuredValue[],
  mappings: MeasurementMappingDto[],
  measurementFields: DataBlockFieldDto[],
): { [key: string]: string | number } {
  console.log('mapMeasuredValues started');

  const values: { [key: string]: string | number } = {};
  mappings
    .filter((mapping) => mapping.isActive)
    .forEach((mapping) => {
      const field = measurementFields.find(
        (field) => field.id === mapping.fieldId,
      );
      if (!field) {
        throw new Error(
          `Measurement field for ${mapping.sourceName} is not found.`,
        );
      }
      try {
        if (mapping.sourceName.startsWith(formulaPrefix)) {
          const formulaResult = calculateFormula(
            mapping.sourceName,
            measuredValues,
          );
          if (!formulaResult) {
            if (mapping.isMandatory) {
              throw new Error(
                `Some variables are not found for mandatory field '${field.name}'`,
              );
            }
          } else {
            values[field.name] = formulaResult;
          }
          return;
        }
        const measuredValue = measuredValues.find(
          (value) => value.key === mapping.sourceName,
        );
        try {
          if (measuredValue && measuredValue.value) {
            if (
              field.dataType === DataType.DateTime ||
              field.dataType === DataType.DateOnly
            ) {
              values[field.name] = new Date(measuredValue.value).toISOString();
              return;
            } else if (field.dataType === DataType.TimeOnly) {
              values[field.name] = parseFhirTime(
                measuredValue.value,
              ).toString();
            } else if (field.dataType === DataType.Number) {
              values[field.name] = parseFloat(
                measuredValue.value.replace(',', '.'),
              );
            } else {
              values[field.name] = measuredValue.value;
            }
          } else if (mapping.isMandatory) {
            if (measuredValue && !measuredValue.value) {
              throw new Error(
                `Can't find value for mandatory field '${field.name}'`,
              );
            }
            throw new Error(`Key ${mapping.sourceName} is not found.`);
          }
        } catch (error) {
          console.error('Error mapping value:', measuredValue, error);
          throw new Error(
            `Error mapping field '${mapping.sourceName}' with value '${
              measuredValue?.value
            }' to ${localizeDataType(field.dataType)}. ${error}`,
          );
        }
      } catch (error) {
        console.error('field', field, 'mapping', mapping, error);
        if (!mapping.ignoreErrors) {
          if (!(error as any).message?.includes('Error mapping')) {
            throw new Error(
              `Error mapping field '${
                mapping.sourceName
              }'  to ${localizeDataType(field.dataType)}. ${error}`,
            );
          }
          throw error;
        }
      }
    });

  return values;
}
